/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_GenresInputs */

const id_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const ms_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const da_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genrer`)
};

const de_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres`)
};

const en_us2_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres`)
};

const es_es2_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Géneros`)
};

const es_mx2_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Géneros`)
};

const fil_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Genre`)
};

const fr_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres`)
};

const it_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generi`)
};

const hu_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Műfajok`)
};

const nl_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres`)
};

const no_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjangre`)
};

const pl_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gatunki`)
};

const pt_br2_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gêneros`)
};

const pt_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Géneros`)
};

const ro_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genuri`)
};

const fi_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lajityypit`)
};

const sv_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genrer`)
};

const vi_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thể loại`)
};

const tr_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türler`)
};

const cs_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žánry`)
};

const bg_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жанрове`)
};

const ru_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жанры`)
};

const uk_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жанри`)
};

const ar_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأنواع`)
};

const hi_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शैलियाँ`)
};

const th_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แนวเกม`)
};

const ja_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジャンル`)
};

const zh_cn2_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类型`)
};

const zh_hant1_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`類型`)
};

const ko_nav_genres = /** @type {(inputs: Nav_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`장르`)
};

/**
* | output |
* | --- |
* | "Genres" |
*
* @param {Nav_GenresInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_genres = /** @type {((inputs?: Nav_GenresInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_GenresInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_genres(inputs)
	if (locale === "ms") return ms_nav_genres(inputs)
	if (locale === "da") return da_nav_genres(inputs)
	if (locale === "de") return de_nav_genres(inputs)
	if (locale === "en-US") return en_us2_nav_genres(inputs)
	if (locale === "es-ES") return es_es2_nav_genres(inputs)
	if (locale === "es-MX") return es_mx2_nav_genres(inputs)
	if (locale === "fil") return fil_nav_genres(inputs)
	if (locale === "fr") return fr_nav_genres(inputs)
	if (locale === "it") return it_nav_genres(inputs)
	if (locale === "hu") return hu_nav_genres(inputs)
	if (locale === "nl") return nl_nav_genres(inputs)
	if (locale === "no") return no_nav_genres(inputs)
	if (locale === "pl") return pl_nav_genres(inputs)
	if (locale === "pt-BR") return pt_br2_nav_genres(inputs)
	if (locale === "pt") return pt_nav_genres(inputs)
	if (locale === "ro") return ro_nav_genres(inputs)
	if (locale === "fi") return fi_nav_genres(inputs)
	if (locale === "sv") return sv_nav_genres(inputs)
	if (locale === "vi") return vi_nav_genres(inputs)
	if (locale === "tr") return tr_nav_genres(inputs)
	if (locale === "cs") return cs_nav_genres(inputs)
	if (locale === "bg") return bg_nav_genres(inputs)
	if (locale === "ru") return ru_nav_genres(inputs)
	if (locale === "uk") return uk_nav_genres(inputs)
	if (locale === "ar") return ar_nav_genres(inputs)
	if (locale === "hi") return hi_nav_genres(inputs)
	if (locale === "th") return th_nav_genres(inputs)
	if (locale === "ja") return ja_nav_genres(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_genres(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_genres(inputs)
	return ko_nav_genres(inputs)
});
export { nav_genres as "nav.genres" }